const formatPercentage = (portion, total, decimals = 0) => {
  return (portion/total * 100).toFixed(decimals) + '%';
};

export { formatPercentage };



// WEBPACK FOOTER //
// ./client/src/libs/num.js